module.exports = __webpack_public_path__ + "static/surf-school-prices.13f1651d.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/prices/surf-school-prices.pdf
// module id = 230
// module chunks = 35783957827783 267625579013595